import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.wallet,
    props.app.buttons.verification,
    (wallet, button) => {
        return {
            wallet,
            button
        }
    }
)